module.exports = __webpack_public_path__ + "assets/svg/UI/unavailability-empty-sets-e21438.svg";